import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-logo',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-logo works!</p> `,
  styles: ``,
})
export class CpLogoComponent {}
